<template>
  <div>
    <h6 class="mb-2">Välj en gymnasiereform</h6>
    <v-select v-model="initialValue" :items="highschoolReforms" label="Välj en gymnasiereform" persistent-hint
      return-object single-line outlined class="mx-auto" @change="onChange($event)"></v-select>
  </div>
</template>

<script>
export default {
  name: 'ProfessionReformSelector',

  data: () => ({
    initialValue: {
      value: 1,
      text: 'Gy11'
    }
  }),

  computed: {
    highschoolReforms() {
      return [
        { value: 1, text: 'Gy11' },
        { value: 2, text: 'Gy25' },
      ]
    }
  },

  methods: {
    onChange(reform) {
      this.$emit('on-change', reform)
    }
  }
};
</script>

<style></style>